import "./styles.css";

function TodosEmpty() {
  return <p>There are no todos...</p>;
}

export { TodosEmpty };
